(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-ingredient-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aa-ingredient-story')) {
  customElements.define('aa-ingredient-story', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.canvas = this.querySelector('canvas');
      this.context = this.canvas.getContext('2d');
      this.urls = JSON.parse(this.querySelector('[data-story-frames]').textContent);
      this.frames = new Map();
      this.pending = new Set();
      this.queue = [];
      this.target = 0;
      this.tick = 0;
      this.drawn = -1;
      this.active = false;
      const signal = this.controller.signal;
      window.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
      window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      this.observer = new IntersectionObserver(entries => {
        this.active = entries[0].isIntersecting;
        if (this.active) this.schedule();
      }, { rootMargin: '300px' });
      this.observer.observe(this);
      this.mode();
    }
    mode() {
      this.staticMode = !this.context;
      this.dataset.static = String(this.staticMode);
      this.dataset.motionReason = this.staticMode ? 'canvas-unavailable' : 'automatic-scroll';
      this.schedule();
    }
    schedule() {
      if (this.tick || this.staticMode || !this.active) return;
      this.tick = requestAnimationFrame(() => { this.tick = 0; this.update(); });
    }
    update() {
      const chapters = this.querySelector('.aa-story__chapters').getBoundingClientRect();
      const mobile = matchMedia('(max-width: 749px)').matches;
      const focus = innerHeight * (mobile ? .76 : .54);
      const first = this.querySelector('.aa-story__chapter').getBoundingClientRect().height / 2;
      const progress = Math.max(0, Math.min(1, (focus - chapters.top - first) / Math.max(1, chapters.height - first * 2)));
      this.style.setProperty('--story-progress', progress);
      this.target = Math.round(progress * (this.urls.length - 1));
      this.queue = [this.target];
      for (let offset = 1; offset <= 10; offset++) this.queue.push(this.target + offset, this.target - offset);
      this.queue = this.queue.filter(i => i >= 0 && i < this.urls.length && !this.frames.has(i) && !this.pending.has(i));
      this.pump();
      this.draw();
    }
    pump() {
      if (!this.isConnected || this.staticMode) return;
      while (this.pending.size < 4 && this.queue.length) {
        const index = this.queue.shift();
        if (this.frames.has(index) || this.pending.has(index)) continue;
        this.pending.add(index);
        const signal = this.controller.signal;
        const img = new Image();
        img.decoding = 'async';
        img.onload = () => {
          this.pending.delete(index);
          if (!this.isConnected || signal.aborted) return;
          this.frames.set(index, img);
          if (this.frames.size > 24) {
            const furthest = [...this.frames.keys()].sort((a, b) => Math.abs(b - this.target) - Math.abs(a - this.target))[0];
            this.frames.delete(furthest);
          }
          this.draw(); this.pump();
        };
        img.onerror = () => { this.pending.delete(index); this.pump(); };
        img.src = this.urls[index];
      }
    }
    draw() {
      if (this.staticMode || !this.frames.size || !this.isConnected) return;
      const nearest = [...this.frames.keys()].sort((a, b) => Math.abs(a - this.target) - Math.abs(b - this.target))[0];
      if (nearest === this.drawn) return;
      this.context.drawImage(this.frames.get(nearest), 0, 0, this.canvas.width, this.canvas.height);
      this.drawn = nearest;
      this.canvas.dataset.frame = String(nearest);
      this.dataset.ready = 'true';
    }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.tick);
      this.frames?.clear(); this.queue = [];
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
